import React from 'react';
import { Layout, Row, Col } from 'antd';
import { gutterDefault, listMedia, listMenu, review,itemsFooter2 } from './constant'
import { TextCustom } from '../../../text';
const { Footer } = Layout;


const FooterLayout = () => {

  return <><Footer className='footer'>
    <Row gutter={gutterDefault} className='show-desktop'>
      <Col className="gutter-row" span={18}>
        {review}
        {listMedia}
      </Col>
      <Col className="gutter-row" span={6}>
        {listMenu}
      </Col>
    </Row>
    <Row gutter={gutterDefault} className='show-mobile'>
      <Col className="gutter-row" span={14}>
        {listMenu}
      </Col>
      <Col className="gutter-row" span={10}>
        {listMedia}
      </Col>

    </Row>

  </Footer>
    <Footer className='footer2'>
      {itemsFooter2}
    </Footer>
    </>
};



export default FooterLayout;
